var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("static-loading-indicator-icon"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row equal" },
        _vm._l(_vm.posts, function(post) {
          return _c(
            "div",
            { key: post.id, staticClass: "col-md-6 col-12 mb-5" },
            [_c("blog-post-card", { attrs: { post: post } })],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: { data: _vm.paginationData },
        on: { "pagination-change-page": _vm.getBlogPosts }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }